import {
    IBeautifiedSlideMapObj,
    IChangeTemplateService,
    IChangeTemplateServiceProps,
    IRect,
    MetaOfTemplate,
    SearchResult } from '@src/slide/application/service/change-template-service/index.interface';
import i18n from '@i18next/i18n';
import { transaction, getTransactionByStoreService } from '@src/slide/domain/slide-app';
import { observable } from 'mobx';
import { IMasterModel } from '@src/slide/domain/ui-model/element-modeles/Interface/master-model.interface';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import {
    ITemplateContentAnalyzerService,
    TContentsNumberType,
    IUserAnalyzerResult,
    ITemplateAnalyzerResult,
    IVerifiedContentsTitle,
    IVerifiedCoverTitle,
} from '@src/slide/application/service/template-content-analyzer-service/index.interface';
import {
    PresentationModelSdkTypeV3,
} from '@src/slide/domain/ui-model/element-modeles/Interface/presentation-model.interface';
import {
    DataType,
    IDrawingShapeData,
    IDrawingShapeDataModel,
    ILayoutDataModel,
    IMasterDataModel,
    IPresentationData,
    IPresentationDataModel,
    ISlideData,
    ISlideDataModel,
    STPlaceholderType,
    STSlideSizeType,
} from '@tencent/slide-sdk-model';
import {
    AutoFitType,
    WrapType,
} from '@src/slide/domain/ui-model/element-modeles/property/text/constants/text-style-type';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { CommandSource } from '@tencent/slide-sdk-model/src/manager/command-manager';
import PresentationModel from '@src/slide/domain/ui-model/element-modeles/presentation-model';
import { UiDataService } from '@src/slide/domain/ui-model/service/ui-data-service';
import {
    PageText,
    PageType,
} from '@src/slide/application/service/slide-content-layout-analyzer/core/algorithm/data-structure/page-content';
import {
    TextLeafNode,
} from '@src/slide/application/service/slide-content-layout-analyzer/core/algorithm/data-structure/text-leaf-node';
import cloneDeep from 'lodash/cloneDeep';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import {
    IElementBaseModel,
} from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import ReactDOM from 'react-dom';
import React from 'react';
import TemplateBeautifyDialog from './component/template-beautify-dialog';
import { IHSL, ITDColor, TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { dataValidateAndReport } from '@src/slide/domain/slide-app/utils/data-validate';
import {
    fetchDocDataById,
    fetchTemplateByIdByNonVip,
    fetchTemplateById,
} from '@src/slide/application/service/ai-ssistant/ai-generator/fetch-template';
import { convert } from '@tencent/slide-markdown-converter';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { ptToEmu } from '@src/slide/infrastructure/module/independent/unit';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import { SolidFill } from '@src/slide/domain/ui-model/plugin/referModels/FillClass';
import { IBackgroundFillInfo } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import Loading from '@tencent/dui/lib/components/Loading';
import { element } from 'prop-types';
import { presetColorPalettes } from '@src/slide/domain/ui-model/element-modeles/chart-models/chart-presets/colors';
import { IPresentationStoreService } from '@src/slide/domain/slide-app/core/interfaces/presentation-service.interface';
import { getAidForReport, IAidOptions } from '@tencent/txdocs-aid';

export const CENTER_TITLE_PLACEHOLDER = {
    title: i18n.t('标题'),
    type: STPlaceholderType.ctrTitle,
};

export const TITLE_PLACEHOLDER = {
    title: i18n.t('标题'),
    type: STPlaceholderType.title,
};

export const SUB_TITLE_PLACEHOLDER = {
    title: i18n.t('副标题'),
    type: STPlaceholderType.subTitle,
};

export const CONTENT_PLACEHOLDER = {
    title: i18n.t('内容占位符'),
    type: undefined,
};

export const DATE_PLACEHOLDER = {
    title: i18n.t('日期占位符'),
    type: STPlaceholderType.dt,
};

export const FOOTER_PLACEHOLDER = {
    title: i18n.t('页脚占位符'),
    type: STPlaceholderType.ftr,
};

export const BODY_PLACEHOLDER = {
    title: i18n.t('文本占位符'),
    type: STPlaceholderType.body,
};

export const SLIDE_NUMBER_PLACEHOLDER = {
    title: i18n.t('灯片编号占位符'),
    type: STPlaceholderType.sldNum,
};

export const PICTURE_PLACEHOLDER = {
    title: i18n.t('图片占位符'),
    type: STPlaceholderType.sldNum,
};

export enum EAILayoutType {
    title,
    secHead,
    titleOnly,
    end,
}

export default class ChangeTemplateService implements IChangeTemplateService {
    // 一级模版切换选择的模版
    @observable public selectedName?: string;
    @observable public dialogVisible = false;

    // 更多模版里选择的模版key
    @observable public templateSelectedKey = '';
    // 用户文档预览uiData
    @observable public previewUiDataService: IUiDataService;

    // 话题列表，请求后就记录下，避免重复请求
    public detailList: SearchResult[] = [];

    // 模版数据缓存，避免多次请求
    public templateDataCached = new Map<string, IPresentationData>();
    // 替换的页面中是否有批注
    public hasCommentOnReplaceSlide?: boolean;
    private services: IChangeTemplateServiceProps;

    // todo: 记录没用匹配到目标文档的元素，做原样搬运
    private willReplaceElement = new Map<IElementBaseModel, any>();

    // 记录需要填充美化的页面
    private beautifiedSlideCached = new Map<ISlideModel, IBeautifiedSlideMapObj>();

    // 模版应用的uiData
    // private templateUiDataService: IUiDataService;
    private dialogContainer = document.createElement('div');

    private aid: string;

    public setDelegate = (services: IChangeTemplateServiceProps) => {
        this.services = services;
        this.updateSelectedName();

        SlideDataServices.SDKDataServices.EventManager()
            ?.commandEvents.onUndoRedoChange((args) => {
                if (args.source === CommandSource.Undo || args.source === CommandSource.Redo) {
                    this.updateSelectedName();
                }
            });
    };

    /**
     * 恢复模版预览
     */
    public revertPreviewSlide = async (): Promise<IUiDataService> => {
        const previewPresentationData = this.createPreviewPresentationData();
        const { cloneUiDataService }  = await this.createTemplateUiDataService(previewPresentationData);
        this.previewUiDataService = cloneUiDataService;
        return this.previewUiDataService;
    };

    /**
     * 打开美化modal
     * @param props
     */
    public showTemplateBeautifyDialog = async (props: any) => {
        requestAnimationFrame(async () => {
            this.dialogVisible = true;
            const previewPresentationData = this.createPreviewPresentationData();
            this.previewUiDataService = await this.createUiDataServiceWithNoConvert(previewPresentationData);
            ReactDOM.render(<TemplateBeautifyDialog
                { ...props }
                uiDataService={this.previewUiDataService}
                changeTemplateService={this}
                aid={this.aid}
            />, this.dialogContainer);
        });
    };

    /**
     * 关闭美化modal
     */
    public closeTemplateBeautifyDialog = () => {
        this.dialogVisible = false;
    };

    public addNewMaster = (
        presentationData: IPresentationData,
        isPreview: boolean,
        templateId?: string,
        index?: number,
    ) => {
        const willChangeUiDataService = isPreview ? this.previewUiDataService : this.services.uiDataService;
        const { presentation } = willChangeUiDataService;
        const { masterList } = presentationData;
        const { id, cSld } = masterList[0];
        cSld.name = templateId;
        let newMasterId: string | undefined = undefined;
        const sdkV3 = presentation.sdkData as PresentationModelSdkTypeV3;
        // 导入数据前校验，校验仅上报
        const validator = SlideDataServices.SDKDataServices.DataValidator();
        dataValidateAndReport(presentationData, 'change_template_add_master', DataType.Presentation);
        // 将母版数据添加至当前文档
        const {
            redundantMasterMap,
            masterIdsArr,
        } = sdkV3?.api.addPresentation(presentationData, index ?? presentation.slideCount ?? 0) || {};

        if (redundantMasterMap?.has(id)) {
            newMasterId = redundantMasterMap.get(id) || '';
        } else {
            masterIdsArr?.forEach((map) => {
                if (map?.has(id)) {
                    newMasterId = map.get(id) || '';
                }
            });
        }

        return newMasterId;
    };

    public clearCached = () => {
        this.willReplaceElement = new Map();
        this.beautifiedSlideCached = new Map();
    };

    /**
     * 应用封面切换
     */
    /* eslint-disable complexity */
    public applyCover = (
        userCover: IVerifiedCoverTitle,
        templateCover: IVerifiedCoverTitle,
        userUiDataService: IUiDataService,
        templateUiDataService: IUiDataService,
        willChangeTransaction: (action: () => void) => void,
    ) => {
        let removeSlideIndex: undefined | number = 0;
        let templateSlideIndex: undefined | number = 0;
        let insertSlideModel: ISlideModel | null = null;
        const { presentation } = templateUiDataService;
        if (userCover.ctrTitleLeaf) {
            const userText = userCover.ctrTitleLeaf.text;
            const userShapeElement = userCover.ctrTitleLeaf.contentBlock.visualBlocks[0].info?.element;
            const templateShapeElement = templateCover.ctrTitleLeaf?.contentBlock.visualBlocks[0].info?.element;
            if (templateShapeElement && templateShapeElement.type === UIModelType.SHAPE) {
                const shapeModel = templateShapeElement as IShapeModel;
                const userShapeModel = userShapeElement as IShapeModel;
                willChangeTransaction(() => {
                    shapeModel.updateTextAdjust({
                        autoFitType: AutoFitType.FONT_AUTO_FIT,
                        autoBreakType: WrapType.WRAP,
                    });
                });

                this.applyText(shapeModel, userText);

                // 记录一下将要插入的模版slide和要替换掉旧slide
                insertSlideModel = this.getRelationSlide(shapeModel);
                templateSlideIndex = presentation.children.findIndex(model => model === insertSlideModel);
                removeSlideIndex = this.getRelationSlideIndex(userShapeModel, userUiDataService);

                // 记录一下匹配到的元素，之后利用这个将没匹配到的元素搬运到模版slide
                userShapeElement && this.willReplaceElement.set(userShapeElement, true);
            } else {
                const sdkData: any = {};
                Object.getPrototypeOf(userShapeElement).constructor.convertDataUiToSdk(
                    userShapeElement,
                    sdkData,
                    userCover.pageModel,
                );

                templateCover.pageModel?.sdkData?.api.addShapes([sdkData]);
            }
        }

        insertSlideModel = insertSlideModel || (templateCover.pageModel || null);
        if (insertSlideModel && !this.beautifiedSlideCached.has(insertSlideModel)) {
            this.beautifiedSlideCached.set(insertSlideModel, {
                index: removeSlideIndex,
                templateIndex: templateSlideIndex,
            });
        }

        if (userCover.subTitleLeaf) {
            const userText = userCover.subTitleLeaf.text;
            const shapeElement = templateCover.subTitleLeaf?.contentBlock.visualBlocks[0].info?.element;
            if (shapeElement && shapeElement.type === UIModelType.SHAPE) {
                const shapeModel = shapeElement as IShapeModel;
                willChangeTransaction(() => {
                    shapeModel.updateTextAdjust({
                        autoFitType: AutoFitType.FONT_AUTO_FIT,
                        autoBreakType: WrapType.WRAP,
                    });
                });
                this.applyText(shapeModel, userText);
            }
        }

        if (userUiDataService.presentation.children[removeSlideIndex].commentGroupMap?.size) {
            this.hasCommentOnReplaceSlide = true;
        }
    };

    /**
     * 将用户文本应用到模版
     * @param shapeElement
     * @param userText
     * @public
     */
    public applyText = (shapeElement: IShapeModel, userText: string, options?: any) => {
        const shapeModel = shapeElement as IShapeModel;
        const paragraphList = cloneDeep(shapeModel.paragraphList);
        if (paragraphList?.[0]?.textRuns?.[0]) {
            paragraphList[0].textRuns[0].text = userText;
            paragraphList.splice(1, paragraphList.length - 1);
            paragraphList[0].textRuns.splice(1, paragraphList[0].textRuns.length - 1);
            // if (paragraphList[0].paragraphProps) {
            //     paragraphList[0].paragraphProps.PPTLineHeight = 1;
            //     paragraphList[0].paragraphProps['raw-PPTLineHeight'] = true;
            // }
        }
        shapeModel.updateParagraphList(paragraphList, options);
    };

    /**
     *
     */
    public getRelationSlide = (shapeElement: IElementBaseModel): ISlideModel => {
        const findSlideModelByParent = (model: IBaseModel | null) => {
            if (model?.type === UIModelType.SLIDE || model === null) {
                return model;
            }

            return findSlideModelByParent(model.parent);
        };

        return findSlideModelByParent(shapeElement);
    };

    public getRelationSlideIndex = (shapeElement: IShapeModel, uiDataService: IUiDataService): number => {
        const slideModel = this.getRelationSlide(shapeElement);
        return uiDataService.presentation.children.findIndex(model => model === slideModel);
    };

    public getRelationSlideIndexBySlide = (
        slideModel: ISlideModel,
        uiDataService: IUiDataService,
    ): number => {
        const slideList = uiDataService.presentation.children;
        return slideList.findIndex(model => model === slideModel);
    };


    /**
     * 应用目录切换
     */
    public applyContents = (
        userContents: IVerifiedContentsTitle,
        templateContents: IVerifiedContentsTitle,
        userUiDataService: IUiDataService,
        templateUiDataService: IUiDataService,
        willChangeTransaction: (action: () => void) => void,
    ) => {
        const { presentation } = templateUiDataService;

        // 记录一下将要插入的模版slide和要替换掉旧slide
        const insertSlideModel = templateContents.pageModel;
        const templateSlideIndex = presentation.children.findIndex(model => model === insertSlideModel);
        const removeSlideIndex = this.getRelationSlideIndexBySlide(userContents.pageModel, userUiDataService);
        if (!this.beautifiedSlideCached.has(insertSlideModel)) {
            this.beautifiedSlideCached.set(insertSlideModel, {
                index: removeSlideIndex,
                templateIndex: templateSlideIndex,
            });
        }

        if (userContents.ctrTitleLeaf) {
            const userText = userContents.ctrTitleLeaf.text;
            const userShapeElement = userContents.ctrTitleLeaf.contentBlock.visualBlocks[0].info?.element;
            const templateShapeElement = templateContents.ctrTitleLeaf?.contentBlock.visualBlocks[0].info?.element;
            if (templateShapeElement && templateShapeElement.type === UIModelType.SHAPE) {
                const templateShapeModel = templateShapeElement as IShapeModel;
                willChangeTransaction(() => {
                    templateShapeModel.updateTextAdjust({
                        autoFitType: AutoFitType.FONT_AUTO_FIT,
                        autoBreakType: WrapType.WRAP,
                    });
                });
                this.applyText(templateShapeModel, userText);

                // 记录一下匹配到的元素，之后利用这个将没匹配到的元素搬运到模版slide
                userShapeElement && this.willReplaceElement.set(userShapeElement, true);
            }
        }

        if (userContents.titleLeafList) {
            userContents.titleLeafList.forEach((userTitleLeaf, index) => {
                const userText = userTitleLeaf.text;
                const templateLeaf = templateContents.titleLeafList?.[index];
                const shapeElement = templateLeaf?.contentBlock.visualBlocks[0].info?.element;
                if (shapeElement && shapeElement.type === UIModelType.SHAPE) {
                    const shapeModel = shapeElement as IShapeModel;
                    willChangeTransaction(() => {
                        shapeModel.updateTextAdjust({
                            autoFitType: AutoFitType.FONT_AUTO_FIT,
                            autoBreakType: WrapType.WRAP,
                        });
                    });
                    this.applyText(shapeModel, userText);
                }
            });
        }

        if (userContents.subTitleLeafList) {
            userContents.subTitleLeafList.forEach((userTitleLeaf, index) => {
                const userText = userTitleLeaf.text;
                const templateLeaf = templateContents.subTitleLeafList?.[index];
                const shapeElement = templateLeaf?.contentBlock.visualBlocks[0].info?.element;
                if (shapeElement && shapeElement.type === UIModelType.SHAPE) {
                    const shapeModel = shapeElement as IShapeModel;
                    willChangeTransaction(() => {
                        shapeModel.updateTextAdjust({
                            autoFitType: AutoFitType.FONT_AUTO_FIT,
                            autoBreakType: WrapType.WRAP,
                        });
                    });
                    this.applyText(shapeModel, userText);
                }
            });
        }

        const userTitleLength = userContents.titleLeafList?.length;
        if (
            userTitleLength
            && templateContents.titleLeafList?.length
            && userTitleLength < templateContents.titleLeafList.length
        ) {
            templateContents.titleLeafList.forEach((page, index) => {
                if (index >= userTitleLength) {
                    const templateLeaf = templateContents.titleLeafList?.[index];
                    const shapeElement = templateLeaf?.contentBlock.visualBlocks[0].info?.element;
                    if (shapeElement && shapeElement.type === UIModelType.SHAPE) {
                        const shapeModel = shapeElement as IShapeModel;
                        willChangeTransaction(() => {
                            shapeModel.updateTextAdjust({
                                autoFitType: AutoFitType.FONT_AUTO_FIT,
                                autoBreakType: WrapType.WRAP,
                            });
                        });
                        this.applyText(shapeModel, i18n.t('请输入标题'));
                    }
                }
            });
        }

        if (userContents.pageModel.commentGroupMap?.size) {
            this.hasCommentOnReplaceSlide = true;
        }
    };

    /**
     * 应用章节页切换
     */
    /* eslint-disable complexity */
    public applySection = (
        userSectionList: IVerifiedCoverTitle[],
        templateSection: IVerifiedCoverTitle,
        userUiDataService: IUiDataService,
        templateUiDataService: IUiDataService,
        willChangeTransaction: (action: () => void) => void,
    ) => {
        willChangeTransaction(() => {
            userSectionList.forEach((userSection, index) => {
                let removeSlideIndex: undefined | number;
                if (userSection.ctrTitleLeaf) {
                    const userText = userSection.ctrTitleLeaf.text;
                    const userShapeElement = userSection.ctrTitleLeaf.contentBlock.visualBlocks[0].info?.element;
                    const templateCtrTitleLeaf = templateSection.ctrTitleLeaf;
                    const templateShapeElement = templateCtrTitleLeaf?.contentBlock.visualBlocks[0].info?.element;
                    if (templateShapeElement && templateShapeElement.type === UIModelType.SHAPE) {
                        let userShapeModel;
                        willChangeTransaction(() => {
                            const shapeModel = templateShapeElement as IShapeModel;
                            userShapeModel = userShapeElement as IShapeModel;
                            willChangeTransaction(() => {
                                shapeModel.updateTextAdjust({
                                    autoFitType: AutoFitType.FONT_AUTO_FIT,
                                    autoBreakType: WrapType.WRAP,
                                });
                            });
                            this.applyText(shapeModel, userText);

                            if (userSection.subTitleLeaf) {
                                const userText = userSection.subTitleLeaf.text;
                                const userSubLeaf = userSection.subTitleLeaf;
                                const templateContentBlock = templateSection.subTitleLeaf?.contentBlock;
                                const userSubShapeElement = userSubLeaf.contentBlock.visualBlocks[0].info?.element;
                                const templateSubShapeElement = templateContentBlock?.visualBlocks[0].info?.element;

                                if (templateSubShapeElement && templateSubShapeElement.type === UIModelType.SHAPE) {
                                    const subShapeModel = templateSubShapeElement as IShapeModel;
                                    userShapeModel = userSubShapeElement as IShapeModel;
                                    this.applyText(subShapeModel, userText);
                                }
                            }

                            if (templateSection.indexLeaf?.text) {
                                this.setIndex(templateSection.indexLeaf, index);
                            }

                            if (templateSection.subIndexLeaf?.text) {
                                this.setIndex(templateSection.subIndexLeaf, index);
                            }
                        });

                        // 插入复制出来的章节页
                        willChangeTransaction(() => {
                            const slideModel = this.getRelationSlide(templateShapeElement);
                            const slideModelData = slideModel.sdkData?.getCloneData() as ISlideData;
                            templateUiDataService.presentation.sdkData?.api.addSlides([slideModelData]);
                        });

                        // 记录一下将要插入的模版slide和要替换掉旧slide
                        const { presentation } = templateUiDataService;
                        const sectionIndex = presentation.children.length - 1;
                        const insertSlideModel = presentation.children[sectionIndex];
                        const templateSlideIndex = presentation.children.findIndex(model => model === insertSlideModel);
                        removeSlideIndex = this.getRelationSlideIndex(userShapeModel, userUiDataService);

                        if (!this.beautifiedSlideCached.has(insertSlideModel)) {
                            this.beautifiedSlideCached.set(insertSlideModel, {
                                index: removeSlideIndex,
                                templateIndex: templateSlideIndex,
                            });
                        }

                        // 记录一下匹配到的元素，之后利用这个将没匹配到的元素搬运到模版slide
                        userShapeElement && this.willReplaceElement.set(userShapeElement, true);

                        if (userUiDataService.presentation.children[removeSlideIndex].commentGroupMap?.size) {
                            this.hasCommentOnReplaceSlide = true;
                        }
                    }
                }
            });
        });
    };

    public setIndex(indexLeaf: TextLeafNode, index: number) {
        let templateIndexText = indexLeaf?.text?.toLowerCase();
        const tempLeaf = indexLeaf;
        const templateSubShapeElement = tempLeaf?.contentBlock.visualBlocks[0].info?.element;
        if (templateSubShapeElement?.type === UIModelType.SHAPE && templateIndexText) {
            const shapeModel = templateSubShapeElement as IShapeModel;

            const regNumber = /0?[\d]$/;
            const regNumberSimpleFont = /一/;
            const regNumberComplexFont = /壹/;
            const regNumberEnglish = /one/;
            const regNumberText = regNumber.exec(templateIndexText)?.[0];
            const regSimpleFontText = regNumberSimpleFont.exec(templateIndexText)?.[0];
            const regComplexFontText = regNumberComplexFont.exec(templateIndexText)?.[0];
            const regEnglishText = regNumberEnglish.exec(templateIndexText)?.[0];
            let text = '';
            if ((regNumberText?.length || 0) > 0 && index < 10) {
                text = `${index + 1}`;
                text = `0${text}`;
                templateIndexText = templateIndexText.replace(regNumber, text);
            }

            if ((regSimpleFontText?.length || 0) > 0 && index < 10) {
                const simpleFontMap = [i18n.t('一'), i18n.t('二'), i18n.t('三'), i18n.t('四'), i18n.t('五'), i18n.t('六'), i18n.t('七'), i18n.t('八'), i18n.t('九')];
                text = `${simpleFontMap[index]}` || '';
                templateIndexText = templateIndexText.replace(regNumberSimpleFont, text);
            }

            if ((regComplexFontText?.length || 0) > 0 && index < 10) {
                const complexFontMap = [i18n.t('壹'), i18n.t('贰'), i18n.t('叁'), i18n.t('肆'), i18n.t('伍'), i18n.t('陆'), i18n.t('柒'), i18n.t('捌'), i18n.t('玖')];
                text = `${complexFontMap[index]}` || '';
                templateIndexText = templateIndexText.replace(regNumberComplexFont, text);
            }

            if ((regEnglishText?.length || 0) > 0 && index < 10) {
                const englishFontMap = [
                    'one',
                    'two',
                    'three',
                    'four',
                    'five',
                    'six',
                    'seven',
                    'eight',
                    'nine'];
                text = `${englishFontMap[index]}` || '';
                templateIndexText = templateIndexText.replace(regNumberEnglish, text);
            }


            this.applyText(shapeModel, templateIndexText?.toUpperCase());
        }
    }

    /**
     * 应用封底
     */
    public applyCoverBack = (
        userCover: IVerifiedCoverTitle,
        templateCover: IVerifiedCoverTitle,
        uiDataService: IUiDataService,
        templateUiDataService: IUiDataService,
    ) => {
        let removeSlideIndex: undefined | number;
        let insertSlideModel: ISlideModel | null;
        const { presentation } = templateUiDataService;
        if (userCover.ctrTitleLeaf) {
            const userText = userCover.ctrTitleLeaf.text;
            const userShapeElement = userCover.ctrTitleLeaf.contentBlock.visualBlocks[0].info?.element;
            const templateShapeElement = templateCover.ctrTitleLeaf?.contentBlock.visualBlocks[0].info?.element;
            if (templateShapeElement && templateShapeElement.type === UIModelType.SHAPE) {
                const shapeModel = templateShapeElement as IShapeModel;
                const userShapeModel = userShapeElement as IShapeModel;
                this.applyText(shapeModel, userText);

                // 记录一下将要插入的模版slide和要替换掉旧slide
                insertSlideModel = this.getRelationSlide(shapeModel);
                const templateSlideIndex = presentation.children.findIndex(model => model === insertSlideModel);
                removeSlideIndex = this.getRelationSlideIndex(userShapeModel, uiDataService);
                if (!this.beautifiedSlideCached.has(insertSlideModel)) {
                    this.beautifiedSlideCached.set(insertSlideModel, {
                        index: removeSlideIndex,
                        templateIndex: templateSlideIndex,
                    });
                }

                // 记录一下匹配到的元素，之后利用这个将没匹配到的元素搬运到模版slide
                userShapeElement && this.willReplaceElement.set(userShapeElement, true);
            }
        }

        if (userCover.subTitleLeaf) {
            const userText = userCover.subTitleLeaf.text;
            const shapeElement = templateCover.subTitleLeaf?.contentBlock.visualBlocks[0].info?.element;
            if (shapeElement && shapeElement.type === UIModelType.SHAPE) {
                const shapeModel = shapeElement as IShapeModel;
                this.applyText(shapeModel, userText);
            }
        }
    };

    /**
     * 在模版数据里删除没有缓存的slide
     */
    public deleteUnUseTemplateSlide = (templateUiDataService: IUiDataService) => {
        const removeSlideList: ISlideDataModel[] = [];
        templateUiDataService.presentation.children.forEach((slideModel) => {
            if (!this.beautifiedSlideCached.has(slideModel)) {
                if (slideModel.sdkData) {
                    const slideDataModel = slideModel.sdkData as ISlideDataModel;
                    removeSlideList.push(slideDataModel);
                }
            }
        });

        templateUiDataService.presentation.sdkData?.api?.removeSlides(removeSlideList);
    };

    /**
     * clone一个用户文档uiDataService
     */
    public createPreviewPresentationData = (): IPresentationData => {
        const presentation = this.services.uiDataService.presentation.sdkData as IPresentationDataModel;
        return presentation.getCloneData();
    };


    /**
     * 一级 - 基础切换模版
     * @param presentationData
     * @param isPreview
     */
    public changeTemplate = async (presentationData: IPresentationData, isPreview?: boolean) => {
        // 舍弃模版的slide和备注
        presentationData.slideList = [];
        presentationData.noteSlideMap = {};
        const { uiDataService } = this.services;
        await uiDataService?.forceConvertSlides(uiDataService.presentation.children);
        this.formatLayout(presentationData);
        this.selectedName = presentationData.masterList[0].cSld.name;
        const { themeId } = presentationData.masterList[0];
        const curTheme = presentationData.themeList.find(theme => theme.id === themeId);

        transaction(() => {
            transaction(() => {
                // 先主题映射，避免母版明暗切换时的问题
                this.services.themeColorManager.convertCustomColorToTheme(false);
            });

            let newMasterId = '';
            transaction(() => {
                newMasterId = this.addNewMaster(presentationData, false) || '';
            });

            if (!newMasterId) return;
            transaction(() => {
                const newMasterIndex = this.findMasterIndexByMasterId(newMasterId, this.services.uiDataService);
                const slideList = this.services.uiDataService.presentation.children;
                const { presentation } = this.services.uiDataService;
                if (!presentation?.sdkData) return;
                const masterModel = presentation.sdkData!.masterList[newMasterIndex] as unknown as IMasterDataModel;
                this.formatSlide(slideList);
                slideList.forEach((slideModel, index) => {
                    if (index === 0) {
                        this.setFirstSlide(slideModel, newMasterIndex);
                    } else {
                        const mappingType = this.mappingTitleType(slideModel);
                        const layoutName = this.getMappingName(mappingType);
                        const layoutDataModel = this.classifyAndFormatAITemplate(masterModel, layoutName);
                        this.changeLayout(slideModel, masterModel, layoutDataModel);
                    }
                });
            });

            // 删除不用的master和layout
            this.deleteOldMasterAndLayout(newMasterId);
        });
        this.services.themeColorManager.updateCurrentThemeModel();
    };

    /**
     * 更多主题 - 模版切换
     * @param templateId
     * @param presentationData
     */

    /* eslint-disable complexity */
    public previewBeautifyUi = async (
        templateId: string,
        presentationData: IPresentationData,
        isPreview: boolean,
    ): Promise<IUiDataService> => {
        this.clearCached();

        // 创建一个新的应用模版uiData，提取到文档内容会填充到这个uiData里，美化后会把这个ui插入到原文本里
        const {
            cloneUiDataService: templateUiDataService,
            cloneStoreService: templateStoreService,
        } = await this.createTemplateUiDataService(presentationData);
        const templateTransaction = getTransactionByStoreService(templateStoreService);

        let willChangeUiDataService = this.services.uiDataService;

        // 文档的transaction和预览的transaction不能用一个
        let willChangeTransaction = transaction;
        if (isPreview) {
            // 创建预览uiData，预览时美化的结果会插入到这里，否则插入到原文档里
            const previewPresentationData = this.createPreviewPresentationData();
            const {
                cloneUiDataService,
                cloneStoreService,
            } = await this.createTemplateUiDataService(previewPresentationData);
            willChangeUiDataService = cloneUiDataService;
            if (cloneStoreService) {
                willChangeTransaction = getTransactionByStoreService(cloneStoreService);
            }
            this.previewUiDataService = willChangeUiDataService;
        }

        const module = await this.services.templateContentAnalyzerService.promise();

        // 分析用户文档，拿到目录数量
        const userDoc = await module.analyzerUserDocs({
            templatePresentation: willChangeUiDataService.presentation,
        });

        // 分析模版数据
        const templateAnalyzerResult = await module.analyzerNonStandardTemplate({
            templatePresentation: templateUiDataService.presentation,
        });

        let masterId: string | undefined;
        let oldLayoutNumber = willChangeUiDataService.presentation.layoutList.length;

        // 格式化模版
        templateTransaction(() => {
            this.services.templateFormatService.formatTemplateStandard(templateUiDataService);
        });

        // 美化文档
        willChangeTransaction(() => {
            // 先缩放一次，使模版和文档尺寸匹配
            willChangeTransaction(() => {
                this.scaleTemplateForSameSize(
                    willChangeUiDataService,
                    templateUiDataService,
                );
            });

            let mainFontColor: ITDColor | undefined;
            let hasBack = false;
            let hasBackElement = false;
            let templateFillBackground: IBackgroundFillInfo | undefined | null;
            const {
                firstElement,
                secondElement,
                thirdElement,
                fillBackground,
                pageModel,
                relationLayoutIndex,
            } = templateAnalyzerResult.templateContentBackResult;

            oldLayoutNumber = oldLayoutNumber + (relationLayoutIndex || 0);

            // 填充类美化（封面、章节、正文、封底）
            willChangeTransaction(() => {
                this.applyFillBeautify(
                    userDoc,
                    templateAnalyzerResult,
                    willChangeUiDataService,
                    templateUiDataService,
                    willChangeTransaction,
                );
            });

            // 非填充类美化，做背景插入、版式切换等等
            willChangeTransaction(() => {
                if (templateAnalyzerResult.templateContentBackResult && userDoc.userDocContentResult) {
                    templateFillBackground = fillBackground;
                    const { presentation } = templateUiDataService;

                    const firstIsBack = module.isBackgroundElement({
                        element: firstElement,
                        slide: pageModel,
                        isStrict: true,
                        presentation,
                    });

                    const secondIsBack = module.isBackgroundElement({
                        element: secondElement,
                        slide: pageModel,
                        isStrict: true,
                        presentation,
                    });

                    const thirdIsBack = module.isBackgroundElement({
                        element: thirdElement,
                        slide: pageModel,
                        isStrict: true,
                        presentation,
                    });

                    hasBack = firstIsBack || secondIsBack || thirdIsBack || !!fillBackground;
                    hasBackElement = firstIsBack || secondIsBack || thirdIsBack;

                    if (hasBackElement) {
                        // 清理文档自身背景背景
                        willChangeTransaction(() => {
                            this.handleBackgroundClear(willChangeUiDataService, module);
                        });
                    }

                    mainFontColor = templateAnalyzerResult.mainFontColor;
                    const elements: IElementBaseModel[] = [];
                    firstElement && elements.push(firstElement);
                    secondElement && elements.push(secondElement);
                    thirdElement && elements.push(thirdElement);
                }
            });

            // 删除模版中没有用到slide
            templateTransaction(() => {
                this.deleteUnUseTemplateSlide(templateUiDataService);
            });

            // slide替换逻辑，将填充类美化页替换原有的对应页
            masterId = this.replaceFillSlide({
                templateUiDataService,
                willChangeUiDataService,
                isPreview,
                masterId,
                templateId,
                willChangeTransaction,
            });
            const slideList: ISlideModel[] = [];

            // layout切换逻辑，只切换非填充的
            this.changeLayoutForTemplate({
                willChangeUiDataService, oldLayoutNumber, masterId, slideList, willChangeTransaction,
            });

            // 非填充类替换背景
            willChangeTransaction(() => {
                this.beautifyBackgroundFill({
                    fillBackground: templateFillBackground,
                    slideList,
                    willChangeUiDataService,
                });
            });

            // 非填充页文字色优化，主要保证对比度问题
            willChangeTransaction(() => {
                this.beautifyMainFontColor({
                    mainFontColor, hasBack, templateFillBackground, hasBackElement, slideList,
                });
            });

            willChangeTransaction(() => {
                masterId && this.deleteUnUseMasterAndLayoutAndTheme(willChangeUiDataService);
            });
        });

        return willChangeUiDataService;
    };

    /**
     * 根据presentationData创建clone的uiDataService
     * @param presentationData
     */
    public createTemplateUiDataService = async (presentationData: IPresentationData): Promise<{
        cloneUiDataService: IUiDataService;
        cloneStoreService: IPresentationStoreService;
    }> => {
        const newPresentationStoreService = SlideDataServices.SDKDataServices.PresentationStoreService()!
            .createFromData(presentationData);
        const newSdkPresentation = newPresentationStoreService?.getPresentation();
        const newPresentation = new PresentationModel({
            selectionService: this.services.selectionService,
        });

        const cloneUiDataService = new UiDataService();
        cloneUiDataService.presentation = newPresentation;
        cloneUiDataService.presentation.asyncConvertChildren = false;
        cloneUiDataService.presentation.asyncConvertSlideChildren = false;
        cloneUiDataService.setSlideRenderStateManagerDelegate(this.services.slideRenderStateManager);
        await newPresentation.bindSDK(newSdkPresentation);
        await cloneUiDataService?.forceConvertSlides(cloneUiDataService.presentation.children);
        return {
            cloneUiDataService,
            cloneStoreService: newPresentationStoreService,
        };
    };

    public createUiDataServiceWithNoConvert = async (presentationData: IPresentationData): Promise<IUiDataService> => {
        const newPresentationStoreService: any = SlideDataServices.SDKDataServices.PresentationStoreService()
            ?.createFromData(presentationData);
        const newSdkPresentation = newPresentationStoreService?.presentation;
        const newPresentation = new PresentationModel({
            selectionService: this.services.selectionService,
        });

        const cloneUiDataService = new UiDataService();
        cloneUiDataService.presentation = newPresentation;
        cloneUiDataService.setSlideRenderStateManagerDelegate(this.services.slideRenderStateManager);
        await newPresentation.bindSDK(newSdkPresentation);
        return cloneUiDataService;
    };

    public updateAid(aidOptions: IAidOptions) {
        this.aid = getAidForReport(aidOptions);
    }

    /**
     * 应用模版美化，这里需要考虑vip阻断，不能只在前端做阻断
     * @param id
     */
    public updateTemplateToSlide = async (id: string) => {
        const newPresentationData = await this.getPresentationByVipStop(id);

        // 美化预览
        await this.previewBeautifyUi(
            id,
            newPresentationData,
            false,
        );
    };

    /**
     * 拉取模版数据，不走缓存，且调用带vip阻断的接口
     * @param templateId
     */
    public async getPresentationByVipStop(templateId: string): Promise<IPresentationData> {
        // 考虑到vip阻断，应用模版数据时不走缓存
        const slideFileData = await fetchTemplateById(templateId);
        const presentationData = convert(cloneDeep(slideFileData));
        presentationData.noteSlideMap = {};

        // presentation在美化的过程中，会做内容填充，clone一份，不要修改原始模版数据
        return cloneDeep(presentationData);
    }

    /**
     * 拉取模版数据，有缓存拿缓存
     * @param templateId 模版id
     * @private
     */
    public async getPresentationByCached(templateId: string): Promise<IPresentationData> {
        let newPresentationData;

        // 看看模版缓存，没有就拉一个
        if (!this.templateDataCached.has(templateId)) {
            const slideFileData = await fetchTemplateByIdByNonVip(templateId);
            const presentationData = convert(cloneDeep(slideFileData));
            presentationData.noteSlideMap = {};
            this.templateDataCached.set(templateId, presentationData);
            newPresentationData = presentationData;
        } else {
            newPresentationData = this.templateDataCached.get(templateId);
        }

        // presentation在美化的过程中，会做内容填充，clone一份，不要修改原始模版数据
        return cloneDeep(newPresentationData);
    }

    public getCoverSrc = (metaData: Partial<MetaOfTemplate>) => (metaData?.images?.pc_thumb_2x.url
    || metaData?.images?.pc_preview
    || metaData?.images?.mobile_thumb_2x) as string;

    private beautifyBackgroundFill(props: {
        fillBackground: IBackgroundFillInfo | undefined | null,
        slideList: ISlideModel[],
        willChangeUiDataService: IUiDataService,
    }) {
        const { fillBackground, slideList, willChangeUiDataService } = props;
        if (fillBackground) {
            slideList.forEach((slideModel) => {
                if (willChangeUiDataService.presentation.sdkData && slideModel.sdkData) {
                    const slideSdkList = willChangeUiDataService.presentation.sdkData.slideList || [];

                    // 增加一个保护，待美化页还存在sdk数据（没被移除），才进行背景美化
                    if (slideSdkList.includes((slideModel.sdkData as ISlideDataModel))) {
                        slideModel.getBackgroundFill().updateCurrentFill(fillBackground);
                    }
                }
            });
        }
    }

    /**
     * 美化文字主题色，面向非主题文字
     * @private
     * @param props
     */
    private beautifyMainFontColor(props: {
        mainFontColor: ITDColor | undefined,
        hasBack: boolean,
        templateFillBackground: IBackgroundFillInfo | undefined | null,
        hasBackElement: boolean,
        slideList: ISlideModel[],
    }) {
        const {
            mainFontColor, hasBack, templateFillBackground, hasBackElement, slideList,
        } = props;

        // 分析不出来主体色和背景，就不做主体文字色切换
        if (!mainFontColor || !hasBack) return;

        // 背景和主体色太相似，不切换
        if (templateFillBackground && mainFontColor && !hasBackElement) {
            const templateHsl = templateFillBackground.solidFill?.color?.hsl;
            const mainFontHsl = mainFontColor.hsl;
            if (templateHsl && mainFontHsl) {
                if (
                    Math.abs(templateHsl.H - mainFontHsl.H) < 10
                    && Math.abs(templateHsl.S - mainFontHsl.S) < 10
                    && Math.abs(templateHsl.L - mainFontHsl.L) < 10
                ) {
                    return;
                }
            }
        }

        slideList.forEach((pageModel) => {
            const elementRectMap = new Map<IElementBaseModel, {
                rect: {
                    left: number,
                    top: number,
                    width: number,
                    height: number,
                },
                fillColor: ITDColor,
            }>();

            pageModel.children.forEach((element) => {
                if (!mainFontColor) return;
                const slideSdk = pageModel.sdkData;

                // 如果这个元素已经在sdk里移除了，就不考虑了
                if (slideSdk?.shapeList?.findIndex(value => value === element.sdkData) === -1) return;

                if (
                    element.type !== UIModelType.SHAPE
                    && element.type !== UIModelType.CHART
                    && element.type !== UIModelType.GROUP
                    && element.type !== UIModelType.TABLE
                ) return;
                if (!this.hasSimilarFill(element, elementRectMap, mainFontColor)) {
                    this.changeMainFontColor(element, mainFontColor);
                }
            });
        });
    }

    /**
     * 替换填充类美化影响的slide
     * @private
     * @param props
     */
    private replaceFillSlide(props: {
        templateUiDataService: IUiDataService,
        willChangeUiDataService: IUiDataService,
        isPreview: boolean,
        masterId: string | undefined,
        templateId: string,
        willChangeTransaction: (action: () => void) => void,
    }) {
        const {
            templateUiDataService,
            willChangeUiDataService,
            isPreview,
            templateId,
            willChangeTransaction,
        } = props;
        let {
            masterId,
        } = props;
        willChangeTransaction(() => {
            const addPresentationDataModel = templateUiDataService.presentation.sdkData?.getCloneData();
            if (addPresentationDataModel) {
                addPresentationDataModel.slideList = [];
                const { presentation } = templateUiDataService;

                presentation.children.forEach((slideModel) => {
                    willChangeTransaction(() => {
                        const obj = this.beautifiedSlideCached.get(slideModel);
                        const index = obj?.index || 0;
                        const slideSdkData = slideModel.sdkData?.getCloneData() as ISlideData;
                        const userPresentation = willChangeUiDataService.presentation;
                        if (slideSdkData) {
                            const { children } = userPresentation;
                            const oldSlideSdkData = children[index]?.sdkData as ISlideDataModel;
                            if (oldSlideSdkData) {
                                willChangeTransaction(() => {
                                    const { sdkData } = userPresentation;
                                    sdkData?.api.removeSlides([oldSlideSdkData]);
                                });
                            }
                            willChangeTransaction(() => {
                                addPresentationDataModel.slideList = [slideSdkData];
                                const newMasterId = this.addNewMaster(
                                    addPresentationDataModel,
                                    isPreview,
                                    templateId,
                                    index,
                                );
                                if (!masterId) {
                                    masterId = newMasterId;
                                }
                            });
                        }
                    });
                });
            }
        });
        return masterId;
    }

    /**
     * 对没有做填充美化的slide切换版式
     */
    private changeLayoutForTemplate(props: {
        willChangeUiDataService: IUiDataService,
        oldLayoutNumber: number,
        masterId: string | undefined,
        slideList: ISlideModel[],
        willChangeTransaction: (action: () => void) => void,
    }) {
        const {
            willChangeUiDataService,
            oldLayoutNumber,
            masterId,
            slideList,
            willChangeTransaction,
        } = props;
        willChangeTransaction(() => {
            // 遍历没被替换的slide，走版式切换
            const beautifyIndexList: number[] = [];
            this.beautifiedSlideCached.forEach((value, key, map) => {
                beautifyIndexList.push(value.index);
            });

            // 模版商城基本都没有layout
            const userPresentation = willChangeUiDataService.presentation;
            const { sdkData } = userPresentation;
            const layoutList = sdkData?.layoutList || [];
            const layoutModel = layoutList[oldLayoutNumber] as unknown as ILayoutDataModel;
            userPresentation.children.forEach((slideModel, index) => {
                if (!beautifyIndexList.includes(index) && masterId) {
                    slideList.push(slideModel);
                    const newMasterIndex = this.findMasterIndexByMasterId(
                        masterId
                        , willChangeUiDataService,
                    );
                    const masterModel = sdkData!.masterList[newMasterIndex] as unknown as IMasterDataModel;
                    layoutModel && slideModel.changeLayoutLite(masterModel, layoutModel);
                }
            });
        });
    }

    /**
     * 应用填充类美化
     * @param userDoc
     * @param templateAnalyzerResult
     * @param willChangeUiDataService
     * @param templateUiDataService
     * @private
     */
    private applyFillBeautify(
        userDoc: IUserAnalyzerResult,
        templateAnalyzerResult: ITemplateAnalyzerResult,
        willChangeUiDataService: IUiDataService,
        templateUiDataService: IUiDataService,
        willChangeTransaction: (action: () => void) => void,
    ) {
        this.hasCommentOnReplaceSlide = false;

        // 替换封面
        if (userDoc.userDocCoverResult && templateAnalyzerResult.templateCoverResult) {
            this.applyCover(
                userDoc.userDocCoverResult,
                templateAnalyzerResult.templateCoverResult,
                willChangeUiDataService,
                templateUiDataService,
                willChangeTransaction,
            );
        }

        // 替换目录
        if (userDoc.userDocContentsResult && templateAnalyzerResult.templateContentsResult) {
            this.applyContents(
                userDoc.userDocContentsResult,
                templateAnalyzerResult.templateContentsResult,
                willChangeUiDataService,
                templateUiDataService,
                willChangeTransaction,
            );
        }

        // 替换章节
        if (userDoc.userDocSectionResult?.length && templateAnalyzerResult.templateSectionResult) {
            this.applySection(
                userDoc.userDocSectionResult,
                templateAnalyzerResult.templateSectionResult,
                willChangeUiDataService,
                templateUiDataService,
                willChangeTransaction,
            );
        }

        // 替换封底 todo: 先忽略封底，考虑下附录场景
        // if (userDoc.userDocBackCoverResult && templateAnalyzerResult.templateBackCoverResult) {
        //     this.applyCoverBack(
        //         userDoc.userDocBackCoverResult,
        //         templateAnalyzerResult.templateBackCoverResult,
        //         willChangeUiDataService,
        //         templateUiDataService,
        //     );
        // }
    }

    /**
     * 清除原有背景/背景元素，用于插入分析出来的背景元素
     * @param willChangeUiDataService
     * @param module
     * @private
     */
    private handleBackgroundClear(willChangeUiDataService: IUiDataService, module: ITemplateContentAnalyzerService) {
        const { presentation } = willChangeUiDataService;
        willChangeUiDataService.presentation.children.forEach((slideModel) => {
            const removeElements: IElementBaseModel[] = [];
            slideModel.children.forEach((element) => {
                if (module.isBackgroundElement({
                    element,
                    slide: slideModel,
                    isStrict: true,
                    presentation,
                })) {
                    removeElements.push(element);
                }
            });

            slideModel?.getBackgroundFill().updateCurrentFill({});
            removeElements.length && slideModel.deleteElement(removeElements);
        });
    }

    /**
     * 将模版和待美化文档统一成一个尺寸
     * @param willChangeUiDataService
     * @private
     */
    private scaleTemplateForSameSize(
        willChangeUiDataService: IUiDataService,
        templateUiDataService: IUiDataService,
    ) {
        const uiWidth = willChangeUiDataService.presentation.props.slideWidth;
        const uiHeight = willChangeUiDataService.presentation.props.slideHeight;
        const templateWidth = templateUiDataService.presentation.props.slideWidth;
        const templateHeight = templateUiDataService.presentation.props.slideHeight;
        const scaleX = templateWidth / uiWidth;
        const scaleY = templateHeight / uiHeight;
        if (scaleX !== 1 || scaleY !== 1) {
            willChangeUiDataService.presentation.updateCustomSlideSize(
                ptToEmu(templateWidth) / 2,
                ptToEmu(templateHeight) / 2,
                scaleX,
                STSlideSizeType.custom,
            );
        }
    }

    private checkSimilarHsl = (templateHsl: IHSL, mainFontHsl: IHSL): boolean => {
        const diffL = Math.abs(templateHsl.L - mainFontHsl.L);

        if (diffL < 20) {
            return true;
        } if (diffL < 50) {
            const diffH =  Math.abs(templateHsl.H - mainFontHsl.H);
            if (diffH < 30) {
                return true;
            }

            if (Math.abs(diffH - 255) < 30) {
                return true;
            }
        }

        return false;
    };

    private hasSimilarFill = (element: IElementBaseModel, elementRectMap: Map<IElementBaseModel, {
        rect: IRect,
        fillColor: ITDColor,
    }>, mainFontColor: ITDColor): boolean => {
        let flag = false;
        const newRect = this.getRect(element);
        const fillTDColor = this.getFillColor(element);
        elementRectMap.forEach((value, key) => {
            const { rect, fillColor } = value;
            if (this.checkRectOverLap(rect, newRect)) {
                if (this.checkSimilarHsl(fillColor.hsl, mainFontColor.hsl)) {
                    flag = true;
                }
            }
        });

        if (newRect && fillTDColor) {
            elementRectMap.set(element, {
                rect: newRect,
                fillColor: fillTDColor,
            });
        }

        return flag;
    };

    private getFillColor = (element: IElementBaseModel): ITDColor | null | undefined => {
        const { fillBackground } = element.props.style;
        return fillBackground?.solidFill?.color;
    };

    private getRect = (element: IElementBaseModel): IRect => {
        const { props } = element;
        const { style } = props;
        return {
            left: style.left,
            top: style.top,
            width: style.width,
            height: style.height,
        };
    };

    private checkRectOverLap = (rect: IRect, newRect: IRect) => {
        const x1 = rect.left;
        const x2 = rect.left + rect.width;
        const y1 = rect.top;
        const y2 = rect.top + rect.height;

        const x3 = newRect.left;
        const x4 = newRect.left + newRect.width;
        const y3 = newRect.top;
        const y4 = newRect.top + newRect.height;

        if (y1 > y4) return false;
        if (x2 < x3) return false;
        if (y2 < y3) return false;
        if (x1 > x4) return false;

        return true;
    };

    /**
     * 更改元素文字主体色
     * @param element
     * @param mainColor
     */
    private changeMainFontColor = (element: IElementBaseModel, mainColor: ITDColor) => {
        switch (element.type) {
            case UIModelType.SHAPE:
                this.changeMainFontColorForShape(element as IShapeModel, mainColor);
                break;
            case UIModelType.GROUP:
                this.changeMainFontColorForGroup(element as IGroupModel, mainColor);
                break;
            case UIModelType.TABLE:
                (element as ITableModel).clearAllCellFill();
                (element as ITableModel).updateTblProp({
                    tableStyleId: '{5C22544A-7EE6-4342-B048-85BDC9FD1C3A}',
                    firstRow: true,
                    bandRow: true,
                });
                break;
            case UIModelType.CHART:
                if (
                    !(element as IChartModel).props?.style?.fillBackground
                    || (element as IChartModel).props?.style?.fillBackground?.noFill === 1) {
                    (element as IChartModel).updateProps({
                        chartSpace: {
                            props: {
                                style: {
                                    fillBackground: {
                                        solidFill: new SolidFill(new TDColor({
                                            rgbaStr: '#ffffff',
                                        })),
                                    } } } } });
                }
                (element as IChartModel).chartProperty.updateChartColors(presetColorPalettes.colorful[0]);
                break;
            default:
                return;
        }
    };

    private changeMainFontColorForGroup = (groupElement: IGroupModel, mainColor: ITDColor) => {
        groupElement.children.forEach((element) => {
            if (element.type === UIModelType.GROUP) {
                this.changeMainFontColorForGroup(element as IGroupModel, mainColor);
            } else if (element.type === UIModelType.SHAPE) {
                this.changeMainFontColorForShape(element as IShapeModel, mainColor);
            } else if (element.type === UIModelType.CHART) {
                // todo: 单独处理图表
                // const chartModel = element as IChartModel;
                // if (!chartModel.props?.style?.fillBackground || chartModel.props.style.fillBackground.noFill === 1) {
                //     chartModel.updateProps({
                //         chartSpace: {
                //             props: {
                //                 style: {
                //                     fillBackground: {
                //                         solidFill: new SolidFill(new TDColor({
                //                             rgbaStr: '#ffffff',
                //                         })),
                //                     } } } } });
                // }
            }
        });
    };

    private changeMainFontColorForShape = (shapeElement: IShapeModel, mainColor: ITDColor) => {
        // 有文本，有模版文本色、文本无背景填充，这种情况下替换下文字色
        if (
            shapeElement.paragraphList
            && mainColor
            && (!shapeElement.props.style.fillBackground
                || shapeElement.props.style.fillBackground?.noFill === 1)) {
            const paragraphList = cloneDeep(shapeElement.paragraphList);
            paragraphList.forEach((para) => {
                para.textRuns?.forEach((text) => {
                    if (text.styles) {
                        text.styles.gradFill = null;
                        text.styles.tdColor = mainColor;
                        text.styles['raw-tdColor'] = true;
                        text.styles['raw-color'] = true;
                        text.styles.color = mainColor.srgb_color;
                    }
                });
            });

            shapeElement.updateParagraphList(paragraphList);
        }
    };

    private formatLayout = (targetPresentationData: IPresentationData) => {
        const presentationModel = (
            this.services.uiDataService.presentation.sdkData as unknown as IPresentationDataModel);
        const { cx: targetCx, cy: targetCy } = targetPresentationData.sldSz;
        const { cx: originTargetCx, cy: originTargetCy } = presentationModel.props.sldSz;
        targetPresentationData.sldSz.cx = originTargetCx;
        targetPresentationData.sldSz.cy = originTargetCy;
        const scaleX = targetCx / originTargetCx;
        const scaleY = targetCy / originTargetCy;
        const { layoutMap } = targetPresentationData;
        for (const layoutMapKey in layoutMap) {
            const layout = layoutMap[layoutMapKey];
            for (const shape of layout.cSld.spTree!.shapeList) {
                this.scaleShapeFrame(shape, scaleX, scaleY);
            }
        }
    };

    private scaleShapeFrame(shape: IDrawingShapeData, scaleX: number, scaleY: number) {
        if (!shape.spPr.xfrm) return;
        const { off } = shape.spPr.xfrm;
        const { ext } = shape.spPr.xfrm;
        shape.spPr.xfrm.off = {
            x: (off?.x || 0) / scaleX,
            y: (off?.y || 0) / scaleY,
        };

        shape.spPr.xfrm.ext = {
            cx: (ext?.cx || 0) / scaleX,
            cy: (ext?.cy || 0) / scaleY,
        };
    }

    private moveShapeFrame(shape: IDrawingShapeDataModel, offsetX: number, offsetY: number) {
        if (!shape.getOwnedData().spPr.xfrm) return;

        const { left, top } = shape.getFrame().move(offsetX, offsetY)
            .floor();

        shape.api.updateTransform({
            off: {
                x: left,
                y: top,
            },
        });
    }

    private changeLayout = (slideModel: ISlideModel, masterDataModel, layoutDataModel) => {
        slideModel.changeLayoutLite(masterDataModel, layoutDataModel);
    };

    private findMasterIndexByMasterId = (MasterId: string, uiDataService): number => {
        const presentationModel = uiDataService.presentation.sdkData as unknown as IPresentationDataModel;
        const { masterList = [] } = presentationModel || {};
        return masterList.findIndex((master: IMasterDataModel) => MasterId === master.id);
    };

    /**
     * 分类ai模版，特供非通用，一期会认为切换的模版都是ai模版
     * 目前ai模版比较糙，layout类型不规范且命名非法
     * 所以要现将ai模版归类一下
     * 目前ai只有封面/封底/节标题/仅标题
     */
    private classifyAndFormatAITemplate = (masterModel: IMasterDataModel, layoutName: string): ILayoutDataModel => {
        const templateLayoutList = masterModel.layoutList;
        const index = templateLayoutList.findIndex((layout => layout.props.cSld.name === layoutName));
        return index === -1 ? templateLayoutList[0] : templateLayoutList[index];
    };

    private getMappingName = (mappingType: EAILayoutType): string => {
        switch (mappingType) {
            case EAILayoutType.title:
                return i18n.t('封面');
            case EAILayoutType.secHead:
                return i18n.t('节标题');
            case EAILayoutType.titleOnly:
                return i18n.t('仅标题');
            default:
                return i18n.t('封底');
        }
    };

    private mappingTitleType = (slideModel: ISlideModel) => {
        const slideShapeList = slideModel.children;
        let ctrTitleNumber = 0;
        let subTitleNumber = 0;
        let bodyNumber = 0;
        let titleNumber = 0;
        slideShapeList.forEach((shapeModel) => {
            if (shapeModel.isPlaceholder) {
                if (shapeModel?.placeHolder?.type === 'ctrTitle') {
                    ctrTitleNumber = ctrTitleNumber + 1;
                }

                if (shapeModel?.placeHolder?.type === 'subTitle') {
                    subTitleNumber = subTitleNumber + 1;
                }

                if (shapeModel?.placeHolder?.type === 'body') {
                    bodyNumber = bodyNumber + 1;
                }

                if (shapeModel?.placeHolder?.type === 'title') {
                    titleNumber = titleNumber + 1;
                }
            }
        });

        if (ctrTitleNumber === 1) {
            return EAILayoutType.title;
        }

        if (titleNumber === 1 && bodyNumber === 1) {
            return EAILayoutType.secHead;
        }

        return EAILayoutType.titleOnly;
    };

    /**
     * 首页强制封面
     */
    private setFirstSlide = (slideModel: ISlideModel, masterIndex: number) => {
        const layoutName = this.getMappingName(EAILayoutType.title);
        const { presentation } = this.services.uiDataService;
        const masterModel = presentation.sdkData?.masterList[masterIndex] as unknown as IMasterDataModel;
        const layoutDataModel = this.classifyAndFormatAITemplate(masterModel, layoutName);
        this.changeLayout(slideModel, masterModel, layoutDataModel);
    };

    /**
     * 格式化数据
     * 1、如果有一张大图铺在slide最下层，且大小大于slide大小的80%（目测wps）也视为背景
     * 2、如果有一张大shape在slide最下层，且大小大于slide大小的80%，且没有文字，也视为背景
     * 3、普通背景直接重置
     * 4、占位符索引清理
     */
    private formatSlide = (slideList: ISlideModel[]) => {
        slideList.forEach((slideModel) => {
            // 普通背景
            slideModel.getBackgroundFill().updateCurrentFill({});
            let flag = false;

            // 大图
            const lastElement = slideModel.children[0];
            if (lastElement?.type === UIModelType.IMAGE) {
                const imageElement = lastElement as IPictureModel;
                flag = flag || this.handleImage(slideModel, imageElement);
            }

            // 占位符
            this.handlePlaceholder(slideModel, flag);
        });
    };

    private handleImage = (slideModel: ISlideModel, imageElement: IPictureModel) => {
        let flag = false;
        const { slideWidth, slideHeight } = this.services.uiDataService.presentation.props;
        const { width = 0, height = 0 } = imageElement.props.style || {};
        if (width > slideWidth * 0.9 && height > slideHeight * 0.9) {
            slideModel.deleteElement([imageElement]);
            flag = true;
        }
        return flag;
    };

    private handlePlaceholder = (slideModel: ISlideModel, ignoreFirstElement: boolean) => {
        slideModel.children.forEach((element, index) => {
            if (ignoreFirstElement && index === 0) return;
            if (element.type === UIModelType.SHAPE && element.isPlaceholder && element.placeHolder) {
                const shapeModel = element as IShapeModel;
                shapeModel.updateTextAdjust({
                    autoFitType: AutoFitType.NO_AUTO_FIT,
                    autoBreakType: WrapType.NO_WRAP,
                });
            }
        });
    };

    private deleteOldMasterAndLayout(newMasterId: string) {
        transaction(() => {
            const { presentation } = this.services.uiDataService;
            const removedMaster = presentation.sdkData?.masterList.filter(master => master.id !== newMasterId) || [];

            const removeLayout: ILayoutDataModel[] = [];
            removedMaster?.forEach((master: IMasterDataModel) => {
                removeLayout.push(...master.layoutList);
            });

            presentation.sdkData?.api.removeLayouts(removeLayout);
            presentation.sdkData?.api.removeMasters(removedMaster);
        });
    }

    private deleteUnUseMasterAndLayoutAndTheme = (uiDataService) => {
        const { presentation } = uiDataService;
        const removedMaster: IMasterDataModel[] = [];
        const relationMaster = new Set<IMasterDataModel>();
        const removeLayout: ILayoutDataModel[] = [];

        presentation.sdkData?.slideList.forEach((slideDataModel) => {
            const masterId = slideDataModel.getLayout()?.getMaster()?.id;
            const masterDataModel = presentation.sdkData?.masterList.find(master => master.id === masterId);
            masterDataModel && relationMaster.add(masterDataModel);
        });

        presentation.sdkData?.masterList.forEach((master) => {
            if (!relationMaster.has(master)) {
                removedMaster.push(master);
            }
        });

        removedMaster?.forEach((master: IMasterDataModel) => {
            removeLayout.push(...master.layoutList);
        });

        presentation.sdkData?.api.removeLayouts(removeLayout);
        presentation.sdkData?.api.removeMasters(removedMaster);
    };

    private updateSelectedName() {
        const masterModel: IMasterModel | undefined = this.services.selectionService.currentSlide
            ?.getRelationMasterModel();
        // todo: 查查master的sdkData的类型为啥是slide
        if (masterModel) {
            this.selectedName = masterModel.sdkData?.props.cSld.name;
        }
    }
}
